import { render, staticRenderFns } from "./HowItWorksStudent.vue?vue&type=template&id=7757d3db&lang=pug&"
import script from "./HowItWorksStudent.vue?vue&type=script&lang=js&"
export * from "./HowItWorksStudent.vue?vue&type=script&lang=js&"
import style0 from "./HowItWorksStudent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./HowItWorksStudent.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports